// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles__wrapper___1oFey"};